export const HIT_PROFILE = 'HIT_PROFILE';
export const GET_PROFILE = 'GET_PROFILE';

export const HIT_UPDATE_PROFILE = 'HIT_UPDATE_PROFILE';
